import React, { useState } from "react";
import {  formatDate, formatNumberIndian, handlePayment } from "../../../utilis/common-funtions";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Tooltip } from "@mui/material";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const PaymentDetails = ({ applicantData }) => {
  const paymentDetails = applicantData?.payments || [];
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const toTitleCase = (str) => {
    if (str !== str.toLowerCase()) {
      return str;
    }
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleView = (docs) => {
    setSelectedImages(docs || []);
    setOpenPopup(true);
  };

  return (
    <div className="otherApplicantDetails paymentDetails">
      <div className="applicantDetailsCard">
        <h3 className="titlePersonalHD marginBottom28">{t("stepper.paymentDetails")}</h3>
        <div className="tbResponsive">
          <table>
            <tr>
              <th style={{ color : "#1C252E" }}>{t("paymentDetails.label.srNo")}</th>
              <th style={{ color : "#1C252E" }}>{t("paymentDetails.label.paymentMode")}</th>
              <th style={{ color : "#1C252E" }}>{t("paymentDetails.label.beingPaid")}</th>
              <th style={{ color : "#1C252E" }}>{t("kycDocuments.labels.drawnOn")}</th>
              <th style={{ color : "#1C252E" }}>{t("paymentDetails.label.dated")}</th>
              <th style={{ color : "#1C252E" }}>{t("corporatePaymentOption.paymentOptionForm.amount")}</th>
              <th style={{ color : "#1C252E" }}>{t("corporatePaymentOption.paymentOptionForm.paymentProofLabel")}</th>
              <th style={{ color : "#1C252E" }}>{t("corporatePaymentOption.paymentOptionForm.chequeDepositSlip")}</th>
            </tr>
            {paymentDetails.length > 0 &&
            paymentDetails.map((payment, index) => {
                const details = payment.paymentDetails || {};

                return (
                    <tr key={payment.id || index}>
                    <td>{index + 1}</td>
                    <td>{payment?.paymentMode? handlePayment(payment?.paymentMode) : "N/A"}</td>
                    <td>{details?.transactionNumber || details?.gatewayPaymentId || details?.chequeNumber || "N/A"}</td>
                    <td>{details?.method?.toLowerCase().includes("upi") ? "UPI": toTitleCase(details?.method || "N/A")}</td>
                    <td>{payment?.date ? formatDate(payment?.date) : "N/A"}</td>
                    <td>
                        <span>₹&nbsp;</span>
                        <span>{formatNumberIndian(Number.parseFloat(payment?.paidAmount) || 0)}</span>
                    </td>
                    <td>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {details?.paymentProof?.length ? (
                          <Tooltip title="View Payment Proof" placement="top" arrow>
                            <IconButton
                              onClick={() => handleView(details?.paymentProof)}
                            >
                              <DescriptionOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Payment Proof Not Available" placement="top" arrow>
                            <span>
                              <IconButton disabled>
                                <DescriptionOutlinedIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                    </td>
                    <td>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {details?.chequeDepositSlip?.length ? (
                          <Tooltip title="View Cheque Deposit Slip" placement="top" arrow>
                            <IconButton
                              onClick={() => handleView(details?.chequeDepositSlip)}
                            >
                              <DescriptionOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Cheque Deposit Slip Not Available" placement="top" arrow>
                            <span>
                              <IconButton disabled>
                                <DescriptionOutlinedIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                    </td>
                    </tr>
                );
            })}
          </table>
        </div>
      </div>
      {openPopup && (
        <UploadPopup
          heading="View"
          totalImages={1}
          closePopup={() => setOpenPopup(false)}
          uploadedImage={selectedImages?.[0] ? [selectedImages[0]] : []}
          fieldName={"paymentProof"}
          hidePhysicalCopyOption
          dynamicSize={1}
          hideCameraOption={false}
          showDeleteIcon={false}
        />
      )}
    </div>
  );
};

export default PaymentDetails;
 